import { localizeDate } from '../../../utils/vuex';
import listOptionsPersistenceMixin from '@/components/custom/listOptionsPersistenceMixin';
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';

const defaultItemsPerPage = 20;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage,
};

export default {
  mixins: [listOptionsPersistenceMixin],
  data: function () {
    return {
      fetchType: 'trackable',
      selectedAccounts: [],

      list: [],
      isFetching: false,
      serverItemsLength: -1,
      fetchOptions: [],

      searchItem: {
        item: null,
        category: 'title',
      },
      lastSearch: '',
      tableOptions: defaultTableOptions,
      defaultTableOptions: { ...defaultTableOptions },

      searchMode: 'single',
      accountsMode: 'multi',

      categoryList: [],
      zoneList: [],
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
  },
  watch: {},
  mounted() {
    this.fetchCategoriesAndZones();
  },
  methods: {
    initializedDefaultPageFilters() {
      const fetchOptions = get(this.$store.state.app, `pageFilters.${this.listPersistencePath}.fetchOptions`) || [];
      this.fetchOptions = fetchOptions;
      this.fetchList();
    },
    localizeDate,
    fetchCategoriesAndZones() {
      ApiService.isAssetMgmtFetchCategoriesAndZones(this, this.fetchType)
        .then((res) => {
          this.categoryList = res.categoryList;
          this.zoneList = res.zoneList;
        })
        .catch((error) => {
          console.error('Error fetching categories and zones', error);
        });
    },
    fetchList(fromStart = false) {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;

      const trimmedSearch = (this.searchItem.item || '').trim();
      let searchItem = undefined;
      if (trimmedSearch) {
        searchItem = {
          variable: this.searchItem.category,
          search: trimmedSearch,
        };
      }

      if (!isEqual(this.lastSearch, searchItem)) {
        this.lastSearch = searchItem;
        this.tableOptions = { ...this.tableOptions, page: 1 };
      }

      const tableOptions = fromStart ? { ...this.tableOptions, page: 1 } : this.tableOptions;
      const { sortBy, sortDesc, page, itemsPerPage } = tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'id';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : false;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';

      const usedPage = page ? page - 1 : 0;
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;

      const filters = [];
      const accountIds = this.selectedAccounts.map((a) => a.id);
      if (accountIds.length) {
        filters.push({ type: 'tenantIds', ids: accountIds });
      }

      // persist options for next call of this page (during this browser-tab-session)
      this.$store.state.app.pageFilters = {
        ...this.$store.state.app.pageFilters,
        IsAssetMgmt: {
          ...(get(this.$store.state.app, 'pageFilters.IsAssetMgmt') || {}),
        },
      };
      if (this.listPersistencePath) {
        const persistPathComp = this.listPersistencePath.split('.');
        this.$store.state.app.pageFilters[persistPathComp[0]][persistPathComp[1]] = {
          searchDetails: this.searchItem,
          tableOptions,
          accountFilter: this.selectedAccounts.map((item) => {
            return { id: item.id };
          }),
          fetchOptions: this.fetchOptions,
        };
      }

      ApiService.isAssetMgmtFetch(
        this,
        this.fetchType,
        usedPage * usedItemsPerPage,
        usedItemsPerPage,
        searchItem,
        filters,
        {
          variable: sortItem,
          direction: sortDirection,
        },
        this.fetchOptions
      )
        .then((res) => {
          this.list = res.assets || res.zones;
          this.serverItemsLength = res.totalCount;
        })
        .catch((error) => {
          console.error(`Error fetching ${this.fetchType}`, error);
        })
        .finally(() => {
          this.isFetching = false;
        });
    },
    resetFilter() {
      this.selectedAccounts = [];
    },
    setCurrentTablePage(value) {
      this.tableOptions.page = value;
    },
  },
};
